<template>
  <svg :class="[$style['svg'], className]" :color="props.color" aria-hidden="true">
    <use :xlink:href="iconName" />
  </svg>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  icon: string
  color?: string,
  className?: string
}>()

const iconName = computed(() => {
  return `#icon-${props.icon}`
})
</script>

<style lang="scss" module>
.svg {
  @apply w-7 h-7 overflow-hidden fill-current
}
</style>
